import * as React from "react";
import { StyledCheckbox } from "./GLCheckbox.styles";
const GLCheckbox = ({ ...props }, ref) => /* @__PURE__ */ React.createElement(StyledCheckbox, null, /* @__PURE__ */ React.createElement("input", { ref, type: "checkbox", ...props }), /* @__PURE__ */ React.createElement("div", { className: "styled-checkbox" }));
export default React.forwardRef(GLCheckbox);
